/**************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
import React from 'react';

import { Switch, Route } from 'react-router-dom';
import { Provider, defaultTheme } from '@adobe/react-spectrum';

import ProductAdmin from './ProductAdmin';
import CategoryProperties from './CategoryProperties';
import ProductAdminContextProvider from './ProductAdminContext';
import ProductProperties from './ProductProperties';
import useLocale from '../common/useLocale';
import {
    browse_category_route,
    browse_product_route,
    properties_product_route,
    properties_category_route,
    browse_root_route,
    browse_config_route
} from './urls';

const ProductAdminRoutes = () => {
    const locale = useLocale();
    return (
        <Switch>
            <Route path={properties_product_route}>
                <Provider theme={defaultTheme} height="100%" colorScheme="light" locale={locale}>
                    <ProductProperties />
                </Provider>
            </Route>
            <Route path={properties_category_route}>
                <Provider theme={defaultTheme} height="100%" colorScheme="light" locale={locale}>
                    <CategoryProperties />
                </Provider>
            </Route>
            <Route path={[browse_product_route, browse_category_route, browse_config_route, browse_root_route, '/']}>
                <ProductAdminContextProvider>
                    <ProductAdmin />
                </ProductAdminContextProvider>
            </Route>
        </Switch>
    );
};

export default ProductAdminRoutes;
